import { motion } from "framer-motion";
import { HelpCircle } from "lucide-react";
import { PAIN_POINTS } from "@/lib/content";

export default function PainPoints() {
  return (
    <section className="section-pad bg-[#0D1B2A] text-white relative overflow-hidden" data-testid="home-pain">
      <div
        aria-hidden
        className="absolute inset-0"
        style={{
          backgroundImage:
            "radial-gradient(50% 50% at 80% 20%, rgba(158,122,68,0.15) 0%, transparent 60%)",
        }}
      />
      <div className="container-sp relative">
        <div className="max-w-3xl">
          <div className="overline" style={{ color: "#E5444A" }}>Before you decide</div>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl mt-3 leading-tight">
            What worries most students before they choose Poland.
          </h2>
          <p className="text-white/70 mt-5 max-w-xl">
            These are the exact concerns we hear every week. Here's how we
            address them — calmly, concretely.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-14">
          {PAIN_POINTS.map((p, i) => (
            <motion.div
              key={p.worry}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.45, delay: i * 0.05 }}
              className="rounded-2xl p-7 border border-white/10 bg-white/[0.03] backdrop-blur-sm"
              data-testid={`pain-point-${i}`}
            >
              <div className="flex items-start gap-3">
                <HelpCircle className="w-5 h-5 text-[#E5444A] mt-0.5 shrink-0" />
                <h3 className="font-serif text-lg leading-snug">{p.worry}</h3>
              </div>
              <p className="text-sm text-white/70 mt-4 leading-relaxed">{p.answer}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
